import { Avatar, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import { DATE_TIME_FORMAT, formatDateTime } from "@shared";

import { SrvProceedingListItemResponse } from "@/api";
import { EllipsisText } from "@/common/components/ellipsis-text/EllipsisText";
import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { formatUserCode } from "@/common/utils/formatUserCode";
import { getSrvProceedingTitle } from "@/pages/clients/client/components/tabs/debt-settlement-tab/tabs/srv-proceeding-tab/SrvProceedingTab.utils";
import { useTranslation } from "@/translations";

const AVATAR_LABEL_MAX_LENGTH = 3;

interface Props {
  proceeding: SrvProceedingListItemResponse;
  selected: boolean;
  onSelect: (proceedingId: string) => void;
}

export function SrvProceedingListItem({ proceeding, selected, onSelect }: Props) {
  const { t } = useTranslation();
  const { language } = useLanguageContext();
  const creatorInitials = formatUserCode(proceeding.createdByUserCode, t).slice(0, AVATAR_LABEL_MAX_LENGTH);

  return (
    <ListItem disablePadding divider>
      <ListItemButton selected={selected} disableRipple onClick={() => onSelect(proceeding.id)}>
        <ListItemAvatar>
          <Avatar alt={creatorInitials}>{creatorInitials}</Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <EllipsisText
              value={getSrvProceedingTitle(proceeding, t)}
              variant="body1"
              fontWeight={selected ? "bold" : "regular"}
            />
          }
          secondary={
            <Typography variant="body2" color="text.secondary">
              {formatDateTime(proceeding.createdAtUtc, DATE_TIME_FORMAT, locales[language])}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  );
}
